__turbopack_context__.v({
  "modalBody": "DeleteOrderModal-module-scss-module__1RkIrG__modalBody",
  "modalContent": "DeleteOrderModal-module-scss-module__1RkIrG__modalContent",
  "modalFooter": "DeleteOrderModal-module-scss-module__1RkIrG__modalFooter",
  "modalHeader": "DeleteOrderModal-module-scss-module__1RkIrG__modalHeader",
});
